(() => {
  const initSection = (section) => {
    if (!section || !section.classList.contains("card-carousel-section")) {
      return;
    }

    const sliderEl = section.querySelector(".js-card-carousel-slider");
    if (!sliderEl) return;

    const nextBtn = section.querySelector(
      ".card-carousel__navigation-button--next"
    );
    const prevBtn = section.querySelector(
      ".card-carousel__navigation-button--prev"
    );
    const slidesEls = sliderEl.querySelectorAll(".swiper-slide");

    const sliderSettings = {
      loop: slidesEls.length > 4 ? true : false,
      slidesPerView: 1,
      spaceBetween: 24,
      simulateTouch: true,
      allowTouchMove: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
        1360: {
          slidesPerView: 4,
          spaceBetween: 56,
        },
      },
    };

    new Swiper(sliderEl, sliderSettings);
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target);
  });
})();
